import React from "react";
import { ReactComponent as CASESTUDY } from "../img/work-link_icons/case_study.svg";

export const CaseStudy = () => {
  return <CASESTUDY title="case study" />;
};
